import axios from 'axios';

import { logError } from '../../infrastructure/error-handling.js';

class OurValuesPageService {
	getOurValuesData(language) {
		return axios
			.post(
				`${
					process.env.REACT_APP_API_ENDPOINT
				}/api/singletons/get/ourValues?lang=${language}`,
			)
			.then(res => res.data)
			.catch(logError);
	}
}

export default new OurValuesPageService();
